import axios from "axios";

const isLocal =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";
const apiUrl = isLocal ? "http://localhost:8080" : "https://registrationsapi.jdmplates.co.uk";
// const apiUrl = "https://registrationsapi.jdmplates.co.uk";

const baseUrl = `${apiUrl}/api/v1`;

const apiRequest = axios.create({ baseURL: baseUrl });

apiRequest.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export { apiUrl, baseUrl, apiRequest };
